import Vue from 'vue';

export default {

  async fetchDprSignatures({ commit }, dprFileId) {
    Vue.$log.debug('loading dpr signatures');
    return Vue.axios
      .get(Vue.$url("dpr-signature?dprFileId=" + (dprFileId || '')))
      .then((rsp) => commit("SET_DPR_SIGNATURES", rsp.data));
  },
  
  async createDprSignature({ commit }, payload) {
    return Vue.axios
      .post(Vue.$url("dpr-signature"), payload)
      .then((rsp) => {
        commit('mShowInfoMessage', 'Signature saved', { root: true });
        return rsp.data;
      })
  },

  async deleteDprSignature({ commit }, payload) {
    return Vue.axios
      .delete(Vue.$url("dpr-signature/" + payload.id))
      .then(() => {
        commit('mShowInfoMessage', 'Signature deleted', { root: true });
      });
  },
}